export default __webpack_public_path__ + "static/3_19-9e63fd1519fb75b950e1c00c9c5205e2.png";